import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface Sluzba {
  id: string;
  title: string;
  slug: string;
  description: string | null;
  icon: string | null;
  details: string[] | null;
  display_order: number | null;
  is_active: boolean | null;
  created_at: string;
}

export const useSluzby = () => {
  const [sluzby, setSluzby] = useState<Sluzba[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSluzby = async () => {
      const { data, error } = await supabase
        .from('sluzby')
        .select('*')
        .order('display_order', { ascending: true });
      
      if (!error && data) {
        setSluzby(data);
      }
      setLoading(false);
    };

    fetchSluzby();
  }, []);

  return { sluzby, loading };
};
